import { IconCar16, IconTrain16, IconWalk16 } from '@cian/ui-kit';
import { RailwayItem } from 'shared/components/TransportAccessibility';
import { ETravelType, IRailway } from 'shared/types/houseInfo/railway';
import { getValue } from './getValue';

const TRAVEL_TYPE_ICON_MAP = {
  byFoot: IconWalk16,
  byCar: IconCar16,
};

export const renderRailways = (railways: IRailway[]) =>
  railways.map((item, index) => {
    const id = getValue(item.id, index);
    const travelType = getValue(item.travelType, ETravelType.ByCar);
    const travelTypeIcon = TRAVEL_TYPE_ICON_MAP[travelType];
    const travelTime = `${item.time} мин.`;

    return (
      <RailwayItem
        icon={IconTrain16}
        name={getValue(item.name, '')}
        travelTime={travelTime}
        travelTypeIcon={travelTypeIcon}
        key={`railway${id}`}
      />
    );
  });
